import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChatBubblePage } from './chat-bubble.page';

const routes: Routes = [
  {
    path: '',
    component: ChatBubblePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChatBubblePageRoutingModule {}
